import { ColumnsType } from "antd/es/table";
import { EmailTemplate, Language } from "@types";
import { EmailTemplatesTableActions } from "@components";
import { Tag } from "antd";
import dayjs from "dayjs";

export const emailTemplatesTable = (
  t: (key: string) => string,
  languageLookup: Record<string, string>,
  languages: Language[]
): ColumnsType<EmailTemplate> => [
  {
    title: t("table.name"),
    dataIndex: "name",
    key: "name",
    width: 240,
  },
  {
    title: t("language"),
    dataIndex: "languageId",
    key: "languageId",
    width: 150,
    render(languageId: string) {
      return languageLookup[languageId] ?? languageId;
    }
  },
  {
    title: t("table.source"),
    dataIndex: "tenantId",
    key: "tenantId",
    width: 180,
    render(tenantId: string | null | undefined) {
      return tenantId ? (
        <Tag color="gold">{t("emailTemplateEditor.source.tenant")}</Tag>
      ) : (
        <Tag color="blue">{t("emailTemplateEditor.source.global")}</Tag>
      );
    }
  },
  {
    title: t("table.subject"),
    dataIndex: "subject",
    key: "subject",
    ellipsis: true,
  },
  {
    title: t("table.status"),
    dataIndex: "state",
    key: "state",
    width: 140,
    render(state: number) {
      return state === 1 ? (
        <Tag color="green">{t("emailTemplateEditor.states.active")}</Tag>
      ) : (
        <Tag color="default">{t("emailTemplateEditor.states.inactive")}</Tag>
      );
    }
  },
  {
    title: t("table.lastUpdated"),
    dataIndex: "dateUpdated",
    key: "dateUpdated",
    width: 180,
    render(dateUpdated: string | undefined, record) {
      const date = dateUpdated ?? record.dateCreated;
      return date ? dayjs(date).format("DD.MM.YYYY HH:mm") : "-";
    }
  },
  {
    title: t("table.actions"),
    key: "actions",
    width: 90,
    render(_, record) {
      return <EmailTemplatesTableActions emailTemplate={record} languages={languages} />;
    },
  }
];